import { keyframes as oldKeyframes } from "packages/styled-components";

export const keyframes = oldKeyframes;
